let alertCache = new Set();

export const showOnce = (key, callback, ttl = 3000) => {
  if (alertCache.has(key)) return;

  alertCache.add(key);
  callback();

  setTimeout(() => {
    alertCache.delete(key);
  }, ttl);
};